import { render, staticRenderFns } from "./shortMessageHistory.vue?vue&type=template&id=23871bd9&scoped=true&"
import script from "./shortMessageHistory.vue?vue&type=script&lang=js&"
export * from "./shortMessageHistory.vue?vue&type=script&lang=js&"
import style0 from "./shortMessageHistory.vue?vue&type=style&index=0&id=23871bd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23871bd9",
  null
  
)

export default component.exports